import { useModel } from "hooks/useModel";
import Button from "pages/configurator/components/button";
import { FunctionComponent, useEffect } from "react";
import { Configurator } from "@rromikas/configurio";
import { useId } from "react-id-generator";
import { ADD_GROUP_BUTTON_TEST_ID, GROUPS_LIST_TEST_ID } from "constants/test";
import classNames from "classnames";

interface GroupsListProps {
  model: ReturnType<typeof useModel>;
  onSelect: (index: number) => void;
  groups: Configurator["options"]["groups"];
  onAdd: () => void;
}

const GroupsList: FunctionComponent<GroupsListProps> = ({ groups, onSelect, onAdd }) => {
  useEffect(() => {}, []);
  const ids = useId(groups.length);

  return (
    <div className="p-6 border-b">
      <div className={classNames("flex justify-between", { "mb-4": groups.length })}>
        <div className="font-bold text-lg">Groups</div>
        <Button className="px-7" data-testid={ADD_GROUP_BUTTON_TEST_ID} variant="primary" onClick={onAdd}>
          Add group
        </Button>
      </div>
      <div data-testid={GROUPS_LIST_TEST_ID}>
        {groups.map((group, i) => {
          return (
            <div
              key={ids[i]}
              onClick={() => onSelect(i)}
              className="h-9 flex items-center justify-between px-4 bg-gray-100 hover:bg-gray-200 cursor-pointer border-b"
            >
              {group.name}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GroupsList;
